import * as i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import LanguageDetector from 'i18next-browser-languagedetector';

const instance = (i18n as any).createInstance();

instance
    .use(reactI18nextModule) // if not using I18nextProvider
    .use(LanguageDetector)
    .init({
        fallbackLng: 'de',
        debug: false,
        interpolation: { escapeValue: false },

        /*react: {
            ns: ['app'],
            wait: false,
            bindI18n: 'languageChanged loaded', //
            bindStore: 'added removed',
            nsMode: 'default',
            load: 'languageOnly',
            backend: {
                loadPath: config.staticUrl + '/locales/{{lng}}/{{ns}}.json',
                queryStringParams: { v: '1.3.5' }
            }
        }*/
    });

// instance.addResourceBundle('en', COMMON_NS, require('@intelingu/core/locales/en/common.json'), true, true);
if (PROJECT_NAME_ENV === "Intelingu") instance.addResourceBundle('de', COMMON_NS, require('@intelingu/core/locales/de/common.json'), true, true);
if (PROJECT_NAME_ENV === "HSE-Methode") instance.addResourceBundle('de', COMMON_NS, require('@intelingu/core/locales/de/common_hse.json'), true, true);
// instance.changeLanguage('de');

export default instance;
